// @flow
import { combineReducers, type Reducer } from "redux";
import dashboard from "./dashboard";
import { initialState as dashboardInitialState } from "./dashboard/state";
import focusLists, { initialState as focusListsInitialState } from "./focus-lists";
import trends, { initialState as trendsInitialState } from "./trends";
import type { ReportingState } from "./types";
import notifications from "./notifications";
import { initialState as notificationsInitialState } from "./notifications/state";
import tasks from "./tasks";

import { initialState as tasksState } from "./tasks/state";
import employee, { initialState as employeeInitialState } from "./employee";
import manager, { initialState as managerInitialState } from "./manager";
import reports, { initialState as reportsState } from "./reports";
import { initialState as firstCareIndexState } from "./first-care-index/state";
import firstCareIndex from "./first-care-index";
import { initialState as referralTrackerState } from "./referral-tracker/state";
import referralTracker from "./referral-tracker";
import modals, { initialState as reportModalsInitialState } from "./modals";
import user from "./user";
import { initialState as userInitialState } from "./user/state";
import health from "./health";
import { initialState as healthInitialState } from "./health/state";
import providers from "./providers";
import { initialState as providersInitialState } from "./providers/state";

export const initialState = {
  dashboard: dashboardInitialState,
  focusLists: focusListsInitialState,
  notifications: notificationsInitialState,
  trends: trendsInitialState,
  employee: employeeInitialState,
  manager: managerInitialState,
  reports: reportsState,
  firstCareIndex: firstCareIndexState,
  referralTracker: referralTrackerState,
  tasks: tasksState,
  modals: reportModalsInitialState,
  user: userInitialState,
  health: healthInitialState,
  providers: providersInitialState,
};

export default (combineReducers({
  dashboard,
  focusLists,
  notifications,
  trends,
  employee,
  manager,
  reports,
  firstCareIndex,
  referralTracker,
  tasks,
  modals,
  user,
  health,
  providers,
}): Reducer<ReportingState, *>);
